import { render } from "./dimensional-farm.vue?vue&type=template&id=7d39e139&scoped=true"
import script from "./dimensional-farm.vue?vue&type=script&lang=js"
export * from "./dimensional-farm.vue?vue&type=script&lang=js"

import "./dimensional-farm.vue?vue&type=style&index=0&id=7d39e139&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d39e139"]])

export default __exports__